import React, {useEffect} from "react";
//Calling WOWjs
import WOW from "wowjs";
import "./App.scss";
import {DHome} from "./layout/DHome/DHome";

function App() {
  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return <DHome />;
}

export default App;
